export default __webpack_public_path__ + "static/media/icon-delete.3777d542.svg";